/** Presentation helpers shared by the server (Discord embeds) and the web app. */
/** `2h 14m`, `43m`, `12d 3h`, `just now`. */
export function formatDuration(ms, options = {}) {
    if (ms === null || ms === undefined || !Number.isFinite(ms))
        return '—';
    const abs = Math.max(0, Math.round(ms));
    if (abs < 60_000) {
        const seconds = Math.round(abs / 1000);
        return options.compact ? `${seconds}s` : seconds <= 5 ? 'just now' : `${seconds}s`;
    }
    const minutes = Math.floor(abs / 60_000) % 60;
    const hours = Math.floor(abs / 3_600_000) % 24;
    const days = Math.floor(abs / 86_400_000);
    if (days > 0)
        return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
    if (hours > 0)
        return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
    return `${minutes}m`;
}
/** Hours as a decimal, e.g. `4.2h`. Used in performance tables. */
export function formatHours(ms) {
    if (ms === null || ms === undefined || !Number.isFinite(ms))
        return '—';
    return `${(ms / 3_600_000).toFixed(1)}h`;
}
export function formatPercent(value, digits = 0) {
    if (value === null || value === undefined || !Number.isFinite(value))
        return '—';
    return `${(value * 100).toFixed(digits)}%`;
}
export function formatTaskReference(reference) {
    return `#${reference}`;
}
/** `LT-5000` — deliberately distinct from a task's `#1001`, so the two never
 * look interchangeable in a DM, an audit line, or a table cell. */
export function formatTicketReference(reference) {
    return `LT-${reference}`;
}
/** Human relative time: `4m ago`, `in 2d`. */
export function formatRelative(iso, now) {
    if (!iso)
        return '—';
    const then = Date.parse(iso);
    if (Number.isNaN(then))
        return '—';
    const delta = then - now;
    const magnitude = formatDuration(Math.abs(delta));
    if (magnitude === '—')
        return '—';
    return delta >= 0 ? `in ${magnitude}` : `${magnitude} ago`;
}
export function truncate(value, max) {
    if (value.length <= max)
        return value;
    return `${value.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
}
//# sourceMappingURL=format.js.map